export default __webpack_public_path__ + "static/media/goopter-ecommerce-seo.18ffac6e.jpg";